import { useNavigate } from "react-router-dom";
import { comics } from "@/mocks/comics";
import SectionTitle from "@/components/feature/SectionTitle";

const categories = [
  {
    tag: "古言",
    desc: "才子佳人，岁月情长",
    image: "https://readdy.ai/api/search-image?query=%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%BA%AD%E8%8A%B1%E6%A0%91%E4%B8%8B%E7%9A%84%E6%89%8D%E5%AD%90%E4%BD%B3%E4%BA%BA%E9%80%A2%E5%85%B3%E7%94%B7%E5%A5%B3%EF%BC%8C%E7%B2%89%E9%87%91%E6%9A%96%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E8%8A%B1%E7%93%A3%E9%A3%98%E8%90%BD%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-guyan&orientation=landscape",
  },
  {
    tag: "宫斗",
    desc: "深宫博弈，步步惊心",
    image: "https://readdy.ai/api/search-image?query=%E9%87%91%E9%94%A6%E5%AE%AB%E6%AE%BF%E5%86%85%E9%9B%85%E5%8F%94%E8%A7%81%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%A6%83%E5%85%94%E5%8F%91%E8%83%8C%E5%BD%B1%EF%BC%8C%E6%9A%97%E7%BA%A2%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-gongdou&orientation=landscape",
  },
  {
    tag: "权谋",
    desc: "棋盘天下，运筹帷幄",
    image: "https://readdy.ai/api/search-image?query=%E6%A3%8B%E7%9B%98%E4%B8%8A%E7%9A%84%E6%9D%A8%E6%9E%9D%E5%92%8C%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%9F%8E%E9%98%B4%E5%BD%B1%EF%BC%8C%E9%87%91%E9%BB%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E6%B0%94%E5%9C%BA%E5%8D%81%E8%B6%B3%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-quanmou&orientation=landscape",
  },
  {
    tag: "武侠",
    desc: "快意恩仇，一剑江湖",
    image: "https://readdy.ai/api/search-image?query=%E6%8F%90%E5%89%91%E7%9A%84%E5%8F%A4%E4%BB%A3%E4%BE%A0%E5%A3%AB%E7%AB%99%E5%9C%A8%E5%B1%B1%E5%B3%B0%E9%93%B6%E6%9C%88%E4%B8%8B%EF%BC%8C%E5%86%B7%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-wuxia&orientation=landscape",
  },
  {
    tag: "仙侠",
    desc: "御剑乘风，逆天改命",
    image: "https://readdy.ai/api/search-image?query=%E9%A3%9E%E5%8D%87%E5%9C%A8%E4%BA%91%E7%AB%AF%E5%B1%B1%E6%B5%B7%E9%97%B4%E7%9A%84%E4%BF%AE%E4%BB%99%E8%80%85%EF%BC%8C%E9%9D%92%E7%BB%BF%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E4%BB%99%E6%B0%94%E7%BC%AD%E7%BB%95%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-xianxia&orientation=landscape",
  },
  {
    tag: "江湖",
    desc: "大漠孤烟，恩怨情仇",
    image: "https://readdy.ai/api/search-image?query=%E6%B2%99%E6%BC%A0%E8%A5%BF%E9%83%A8%E5%8F%A4%E5%9F%8E%E5%AE%A2%E6%A0%88%E7%81%AF%E7%81%AB%EF%BC%8C%E8%B4%BC%E9%A9%AC%E9%95%BF%E9%A3%8E%EF%BC%8C%E6%9A%97%E9%BB%84%E8%93%9D%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=800&height=500&seq=cat-jianghu&orientation=landscape",
  },
];

export default function CategorySection() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-background-100 py-14 md:py-16">
      <div className="container-x">
        <SectionTitle
          kicker="题材直达"
          title="六大题材，总有一部让你上头"
          desc="古言、宫斗、权谋、武侠、仙侠、江湖全题材国漫，分类清晰，点选即达。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {categories.map((cat) => {
            const count = comics.filter((c) => c.tag === cat.tag).length;
            return (
              <button
                key={cat.tag}
                onClick={() => navigate(`/category?tag=${encodeURIComponent(cat.tag)}`)}
                className="group relative overflow-hidden rounded-lg text-left cursor-pointer"
                aria-label={`浏览${cat.tag}漫画`}
              >
                <div className="relative h-40 w-full overflow-hidden md:h-44">
                  <img
                    src={cat.image}
                    alt={`${cat.tag}漫画题材`}
                    title={`${cat.tag}漫画分类`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-transparent"></div>
                  <div className="absolute inset-0 flex flex-col justify-center p-5">
                    <span className="font-heading text-2xl font-bold text-background-50">{cat.tag}漫画</span>
                    <span className="mt-1 text-sm text-background-200">{cat.desc}</span>
                    <span className="mt-3 inline-flex w-fit items-center gap-1 rounded-full bg-background-50/20 px-3 py-1 text-xs text-background-100 backdrop-blur-sm">
                      {count} 部作品<i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}